import styled, { css } from "styled-components";

const LabelStyled = styled.label.attrs(() => ({
  className: "label",
}))`
  ${({ theme, longLabel, tooltipOnly }) => {
    const { colors, media } = theme;

    return css`
      color: ${colors.primary.darkBlue};
      cursor: pointer;
      display: block;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.375;

      ${media.tablet.up} {
        text-wrap: ${longLabel ? "nowrap" : "initial"};
      }

      ${media.mobile.only} {
        flex-wrap: ${longLabel ? "wrap" : "nowrap"};
      }

      .sub-label {
        display: inline-block;
        font-size: 12px;
        padding-left: ${longLabel || tooltipOnly ? "0" : "0.5rem"};

        ${media.tablet.up} {
          padding-left: ${tooltipOnly ? "0" : "0.5rem"};
          display: inline;
        }
      }
    `;
  }};
`;

export default LabelStyled;
